// extracted by mini-css-extract-plugin
module.exports = {"largeTitle":"research-view_largeTitle__Cd0HL","publicationListWrapper":"research-view_publicationListWrapper__yBQfH","publicationWrapper":"research-view_publicationWrapper__2ebcu"};